<template>
  <div class="text-left">
    <b-form>
      <b-form-group label="Tick to retain the Column. Untick to remove the Column:">
        <b-form-checkbox-group id="checkbox-group-2" v-model="selected" name="flavour-2">
          <b-form-checkbox value="pri">PRI</b-form-checkbox>
          <b-form-checkbox value="riskrating">Risk Rating</b-form-checkbox>
        </b-form-checkbox-group>
      </b-form-group>
    </b-form>
  </div>
</template>

<script>
// import { HTTP } from "../../utils/HTTP";
import vSelect from "vue-select";
export default {
  name: "clientProfileManageTpColumn",
  components: {
    vSelect
  },
  data() {
    return {};
  },

  computed: {},
  mounted() {},
  methods: {}
};
</script>

<style scoped>
</style>
